import React from 'react';
import {Button, Divider, Icon} from 'semantic-ui-react';
import { Alert } from 'componentLibrary';

const ManualSubOrganization = ({
  handleSubOrganizationForm,
  toggleManualForm,
  searchAgain,
  children,
}) => (
  <React.Fragment>
    <Divider />
    <Alert
      size="tiny"
      header="No results found in SAM.gov. Please try again or enter suborganization information manually."
      type="error"
      dismissable={false}
    />
    <Button
      primary
      icon
      id="addManualSubOrganization"
      title="Enter suborganization information manually"
      onClick={() => {
        handleSubOrganizationForm(), (toggleManualForm = !toggleManualForm);
      }}
    >
      <Icon name="pencil" />
      &nbsp;&nbsp;Enter suborganization information manually
    </Button>
    <a href="#/" id="manualComponent_searchAgain" onClick={(event) => searchAgain(event)}>
      <Icon name="undo" />
      Try a new search
    </a>
    {children}
  </React.Fragment>
);

export default ManualSubOrganization;
